import { useState } from "react";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { HTML } from "../SchemaTypes";
import { EXCEL_MAXIMUM_CELL_LENGTH } from "../../../helpers/FormValidator";
import WysiwygInput from "../../Input/WysiwygInput";
import Field from "../Field";

const WysiwygField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const [labelNode, setLabelNode] = useState();

  const schema = {
    type: HTML,
    parent,
    validations: {
      required,
      length: { maximum: EXCEL_MAXIMUM_CELL_LENGTH }
    }
  };

  return (
    <Field {...fieldProps} schema={schema} labelRef={setLabelNode}>
      <WysiwygInput {...inputProps} labelNode={labelNode} />
    </Field>
  );
};

export default WysiwygField;
